import { useEffect, useState } from "react";
import {
  getPaginatedValidationNullKeysList,
  getPaginatedValidationNullKeysListWithoutIssue,
} from "../services/resourcesService";
import { nullKeysValidationsMockData } from "../services/constants/resource";

interface IuseFetchPaginatedNullKeysValidations {
  currentValidationResultId: any;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: number;
  pSize: number;
  isDetailedExecutionDataAvailable: boolean;
  isIssuesDataAvailable: boolean;
}

const useFetchPaginatedNullKeysValidations = ({
  currentValidationResultId,
  setIsLoading,
  page,
  pSize,
  isDetailedExecutionDataAvailable,
  isIssuesDataAvailable,
}: IuseFetchPaginatedNullKeysValidations) => {
  const [nullKeysValidation, setNullKeysValidation] = useState<any>([]);
  useEffect(() => {
    const fetchValidationData = async () => {
      try {
        setIsLoading(true);
        let result;

        // Use conditional logic based on is_issues_data_available flag
        if (isIssuesDataAvailable) {
          // Use existing endpoint with issues
          result = await getPaginatedValidationNullKeysList({
            currentValidationResultId,
            page,
            pSize,
          });
        } else {
          // Use new endpoint without issues
          result = await getPaginatedValidationNullKeysListWithoutIssue({
            currentValidationResultId,
            page,
            pSize,
          });
        }

        //Set Mock Data
        // const result: any = nullKeysValidationsMockData;

        setNullKeysValidation(result);
      } catch (err) {
        setNullKeysValidation([]);
      } finally {
        setIsLoading(false);
      }
    };
    if (!isDetailedExecutionDataAvailable) fetchValidationData();
  }, [
    currentValidationResultId,
    page,
    pSize,
    isDetailedExecutionDataAvailable,
    isIssuesDataAvailable,
  ]);

  return [nullKeysValidation];
};

export default useFetchPaginatedNullKeysValidations;
